module.exports = __webpack_public_path__ + "static/witch_4k-4ea267abaa8b0677c976c6e2db20c039.webp";